<template>
    <div class="wrap-pagination">
        <div class="d-flex justify-start align-center">
            <v-progress-linear v-if="isLoading" color="#1976d2" :height="4" indeterminate></v-progress-linear>
        </div>

        <div class="d-flex fill-height mx-2 pt-2 pb-1">
            <div class="justify-start align-center" v-if="showExport">
                <v-speed-dial v-model="fab" direction="right" transition="slide-x-transition" @click.stop style="width: 40px; bottom: 4px">
                    <template v-slot:activator>
                        <v-btn v-model="fab" color="dark-blue-color" width="30px" height="30px" fab>
                            <v-icon small v-if="fab">mdi-close</v-icon>
                            <v-icon v-else>mdi-dots-horizontal</v-icon>
                        </v-btn>
                    </template>

                    <v-btn text outlined class="myprovet-btn-cancel myprovet-table-export-btn" style="bottom: -2px" @click.stop="processingExport ? null : $emit('export')">
                        <v-icon small class="pr-2" style="margin-top: -5px">mdi-file-excel-outline</v-icon>
                        {{ processingExport ? $t('table.wait') : $t('table.export') }}
                    </v-btn>
                </v-speed-dial>
            </div>

            <span v-if="showPagination" class="font-size-xs" :class="fab ? 'fab-buttons-spacing' : ''">
                {{ scope.props.itemsPerPageText }}
            </span>

            <!-- max-width usage: https://github.com/vuetifyjs/vuetify/issues/6275 -->
            <v-select v-if="showPagination" v-model="scope.props.options.itemsPerPage" :items="scope.props.itemsPerPageOptions" :disabled="isLoading" @change="$emit('updateOptions', scope.props.options)" class="ml-4 mr-8" style="max-width: 60px !important" dense hide-details> </v-select>

            <span v-if="showPagination" class="font-size-xs">
                {{ $t('table.range', { from: scope.props.pagination.pageStart + 1, to: scope.props.pagination.pageStop, total: scope.props.pagination.itemsLength }) }}
                {{ $t('table.pages', { count: scope.props.pagination.pageCount }) }}
            </span>

            <v-spacer></v-spacer>

            <v-pagination v-if="showPagination" v-model="scope.props.options.page" :length="scope.props.pagination.pageCount" :disabled="isLoading" total-visible="5" class="mt-1 max-pagination-height" @input="$emit('updateOptions', scope.props.options)"></v-pagination>

            <v-btn v-if="showEmptyAffinityCartButton" text outlined class="mt-1 mr-1 myprovet-btn-cancel btn-clear-qty" @click="$emit('emptyCart')" v-html="isMobile ? $t('orders.affinity.clearQtyShort') : $t('orders.affinity.clearQty')"></v-btn>

            <v-btn v-if="showOrderButton" text outlined class="mt-1 myprovet-btn-ok btn-order" @click="$emit('purchase')" data-cy="datatable-order-button"> {{ $t('common.order') }} </v-btn>
            <v-btn v-if="showExportXMLButton" text outlined class="mt-1 myprovet-btn-ok btn-order" @click="$emit('xml')" data-cy="datatable-order-button"> {{ $t('table.download') }} </v-btn>

            <template v-for="(button, index) in footerActionButtons">
                <v-btn :key="index" text outlined :class="button.class" @click="$emit(button.action)"> {{ tb(button.text) }} </v-btn>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        scope: {
            type: Object,
        },
        isLoading: {
            type: Boolean,
        },
        showOrderButton: {
            type: Boolean,
            default: true,
        },
        showEmptyAffinityCartButton: {
            type: Boolean,
            default: false,
        },
        showExport: {
            type: Boolean,
            default: true,
        },
        isMobile: {
            type: Boolean,
            default: true,
        },
        showPagination: {
            type: Boolean,
            default: true,
        },
        showExportXMLButton:{
            type: Boolean,
            default: false,
        },

        /**
         * @type {Array}
         * @default []
         * @description Array of buttons (objects) to be displayed in the footer
         * @example
         * [
         *  {
         *      text: 'Exportar',
         *      class: 'mt-1 myprovet-btn-ok',
         *      action: 'export',
         *  },
         *  {
         *     ...
         *  },
         * ]
         */
        footerActionButtons: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            fab: false,
            processingExport: false,
        };
    },

    mounted() {
        window.EventBus.$on('export-started', () => {
            this.processingExport = true;
        });
        window.EventBus.$on('export-finished', () => {
            this.processingExport = false;
        });
        window.EventBus.$on('export-failed', () => {
            this.processingExport = false;
        });
    },

    beforeDestroy() {
        window.EventBus.$off('export-started');
        window.EventBus.$off('export-finished');
        window.EventBus.$off('export-failed');
    },
};
</script>

<style scoped>
.fab-buttons-spacing {
    margin-left: 170px;
}
</style>
